'use strict';
const angular = require('angular');
const {copy, isString, toJson} = angular;

export function OrganizationInviteDomainProvider() {
  return {
    $get: [
      '$injector',
      'FirebaseUtil',
      'AuthService',
      '$domainValidation',
      'AbstractDomainClass',
      'OrgMixin',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      'INVITE_STATUS',
      'DEFAULT_ROLES',
      function ($injector, FirebaseUtil, AuthService, $domainValidation, AbstractDomainClass, OrgMixin,
                FirebaseQueueService, ROOT_API_COLLECTION, ROOT_API_SPEC, INVITE_STATUS, DEFAULT_ROLES) {

        var inviteDataConstraints = {
          inviteeEmail: {type: 'email', size: [1, 128]},
          inviteeName: {type: 'string', size: [0, 64], nullable: true},
          inviteeRoleId: {type: 'string', inList: DEFAULT_ROLES.toList()}, // TODO: allow for custom roles
          inviteeRoleCollection: {type: 'string', inList: ['_roles']}, // RoleDomain collection is hard coded here for import simplicity
          organization: {type: 'string'}
        };

        function OrganizationInviteDomain(data) {
          AbstractDomainClass.call(this, OrganizationInviteDomain, data);
        }

        AbstractDomainClass.__inheritFrom(OrganizationInviteDomain, 'OrganizationInviteDomain', 'organization-invites');

        OrganizationInviteDomain.$constraints.addConstraints({
          inviteeEmail: {type: 'email', size: [1, 128]},
          inviteeName: {type: 'string', size: [1, 64], nullable: true},
          inviteeRole: {type: 'DomainLink', domainClass: 'RoleDomain'},
          status: {type: 'string', inList: INVITE_STATUS.toList(), defaultValue: INVITE_STATUS.PENDING},

          organization: {type: 'DomainLink', domainClass: 'OrganizationDomain', links: 'invites', belongsTo: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        OrgMixin(OrganizationInviteDomain);

        OrganizationInviteDomain.validateInvite = function validateInvite(inviteData) {
          var instance = _toRequest(inviteData);
          inviteData.$errors = [];

          for (var field in inviteDataConstraints) {
            if (inviteDataConstraints.hasOwnProperty(field)) {
              inviteData.$errors = $domainValidation.validateConstraint(instance[field], inviteDataConstraints[field], inviteData.$errors, 'OrganizationInviteDomain', field, instance);
            }
          }

          return inviteData.$errors.length === 0;
        };

        /**
         *
         * @param {PersonDomain} alias
         * @returns {{inviteeEmail: string, inviteeName: string, inviteeRole: {id: (POWER_USER|{enumerable, value}), collection: string}, organization: string}}
         */
        OrganizationInviteDomain.createInvite = function createInvite(alias) {
          var inviteData = {
            inviteeEmail: alias && isString(alias.email) ? alias.email : '',
            inviteeName: alias && isString(alias.name) ? alias.name : '',
            inviteeRole: {id: DEFAULT_ROLES.USER, collection: '_roles'}, // RoleDomain collection is hard coded here for import simplicity
            inviteeAlias: alias ? alias.$id : null,
            organization: ''
          };

          // TODO: convert to errors class when validator is updated to properly reintegrate with it
          Object.defineProperty(inviteData, '$errors', {
            configurable: true,
            writable: true,
            value: []
          });

          Object.defineProperty(inviteData, 'toString', {
            configurable: true,
            writable: true,
            value: toString
          });

          return inviteData;
        };

        OrganizationInviteDomain.send = function send(inviteData) {
          // TODO(migration)
          var request = {
            method: 'organizations/invites/send',
            data: toJson(_toRequest(inviteData))
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        OrganizationInviteDomain.prototype.resend = function send() {
          var request = {
            method: 'organizations/invites/resend',
            inviteId: this.$id
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        OrganizationInviteDomain.prototype.cancel = function cancel() {
          var request = {
            method: 'organizations/invites/cancelled',
            inviteId: this.$id
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        //@Override
        OrganizationInviteDomain.prototype.$delete = function $delete() {
          var request = {
            method: 'organizations/invites/delete',
            inviteId: this.$id
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        OrganizationInviteDomain.prototype.toString = toString;

        function toString() {
          return this.inviteeName || this.inviteeEmail;
        }

        function _toRequest(inviteData) {
          if (!inviteData.inviteeRole) return inviteData;
          var request = copy(inviteData);
          request.inviteeRoleId = request.inviteeRole.id;
          request.inviteeRoleCollection = request.inviteeRole.collection;
          delete request.inviteeRole;

          return request;
        }


        return OrganizationInviteDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/domain/OrganizationInviteDomain.js